/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";

import { default as apiConfing } from "../config.json";
import { AxiosResponse } from "axios";
import { QuestionProps, QuestionsProps } from "../typings/register";
import { ComplaintType } from "../typings/complaint";

const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.API_DEVELOPMENT : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Questions`;


export function getRegistertionQuestions(languageId: number, genderId: number): Promise<AxiosResponse<QuestionsProps>> {
  const url = `${apiEndpoint}/GetRegistertionQuestions?languageId=${languageId}&genderId=${genderId}`
  return http.get(url);
}

export function getCitiesAutoComplete(text: string): Promise<AxiosResponse<{ id: number, cityName: string }[]>> {
  const url = `${apiEndpoint}/GetCitiesAutoComplete?q=${text}`;
  return http.get(url);
}

export function getCompleteProfileQuestions(memberCode: number): Promise<AxiosResponse<QuestionProps[]>> {
  const url = `${apiEndpoint}/GetCompleteProfileQuestions?memberCode=${memberCode}`;
  return http.get(url);

}

export function getUpdateQuestionLookingFor(memberCode: number): Promise<AxiosResponse<QuestionProps>> {
  const url = `${apiEndpoint}/GetUpdateQuestionLookingFor?memberCode=${memberCode}`;
  return http.get(url);
}

export function getQuestionById(memberCode: number, questionId: number): Promise<AxiosResponse<QuestionProps>> {
  const url = `${apiEndpoint}/GetQuestionById?memberCode=${memberCode}&questionId=${questionId}`;
  return http.get(url);

}

export function getPersonalStatusQuestion(memberCode: number): Promise<AxiosResponse<QuestionProps>> {
  const url = `${apiEndpoint}/GetPersonalStatusQuestion?memberCode=${memberCode}`;
  return http.get(url);
}

export function getComplaintsType(memberCode: number): Promise<AxiosResponse<ComplaintType[]>> {
  const url = `${apiEndpoint}/GetComplaintsType?memberCode=${memberCode}`;
  return http.get(url);

}

export function getBreakTheIceQuestion(memberCode: number, questionId: number | null, retriveQuesionId = false) {
  let url = `${apiEndpoint}/GetBreakTheIceQuestion?memberCode=${memberCode}&retriveQuesionId=${retriveQuesionId}`;
  if (questionId) url = `${url}&questionId=${questionId}`;
  return http.get(url);
}



export default {
  getRegistertionQuestions,
  getCompleteProfileQuestions,
  getUpdateQuestionLookingFor,
  getQuestionById,
  getPersonalStatusQuestion,
  getBreakTheIceQuestion
};
